import { Typography } from '@mui/material';
import { DetailContainer, DetailValue, StyledLogo } from './Detail.styles';

interface DetailProps {
  label: string;
  value: number | string;
  showCoin?: boolean;
}

const Detail = ({ label, value, showCoin = false }: DetailProps) => (
  <DetailContainer container>
    <Typography>{label}</Typography>
    <DetailValue>
      {value}
      {showCoin && <StyledLogo />}
    </DetailValue>
  </DetailContainer>
);

export default Detail;
